module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), _c('el-row', {
    staticClass: "tac"
  }, [_c('el-col', [_c('el-menu', {
    staticClass: "el-menu-vertical-demo el-menu--dark",
    attrs: {
      "default-active": _vm.defaultIndex,
      "router": true
    }
  }, [(_vm.getWritePrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "dashboard",
      "route": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.dashboard')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getReadPrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "product",
      "route": {
        name: 'product',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.product')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getOrderPrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "order",
      "route": {
        name: 'order',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.order')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getWritePrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "user",
      "route": {
        name: 'user',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.user')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getWritePrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "store",
      "route": {
        name: 'store',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.store')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getWritePrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "subsidiary",
      "route": {
        name: 'subsidiary',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.subsidiary')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getWritePrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "channel",
      "route": {
        name: 'channel',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.channel')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getReadTagOrderPrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "vechainorder",
      "route": {
        name: 'vechainorder',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.vechainorder')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getWritePrivilege == 1) ? _c('el-menu-item', {
    attrs: {
      "index": "admin",
      "route": {
        name: 'admin',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.admin')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.getAdminPrivilege) ? _c('el-menu-item', {
    attrs: {
      "index": "logs",
      "route": {
        name: 'logs',
        query: {
          page: 1
        }
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('sideBar.logs')) + "\n        ")]) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/hermes_svg.svg"),
      "alt": "",
      "height": "65px"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a247687", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a247687"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/sideBar.vue
// module id = 596
// module chunks = 21